import { useEffect,useState } from "react";
import VirtualizedSelect from 'react-virtualized-select';
import axios from "axios";
import {apiUrl} from '../pages/UrlParam'
import Helper from "../pages/Helper";
  const DynamicSelect = ({url, onChange=null, label , value, id, placeholder='',clearable=false, searchable=true, disabled =false, selectedvalue, required=true,filter=null,appendTopOption =[], appendBottomOption=[],ref=null}) => {
  
  const [options2 , setOptions2] = useState({
      [id] :  []
  });

    const handleOnchange = (option) =>{
      if(onChange != null){
        onChange(option);
      }
    }

    useEffect(() => {
      axios.get(`${apiUrl}/api/${url}`)
        .then((response) => {
            if(Array.isArray(response.data)){
               if(filter!=null && response.data.length > 0){
                  response.data = Array.from(response.data).filter(filter)
               }
              const transformedOptions = response.data.map((item, index) => {
                const regex = /{[a-zA-Z0-9_.-]+}/g;
              
                let labelArr = [...label.matchAll(regex)]
                
                var  label2 = label;
                for(let i = 0;i < labelArr.length;i++){
                  for(let key in item) {
                    if(key == labelArr[i].toString().replace("{","").replace("}","")){
                      label2 = label2.replace(labelArr[i].toString(), (typeof(item[key]) == "number" && item[key]?.toString().length > 3) ? Helper.formatAsCurrency(item[key]) : item[key])
                    }
                  }
                }
             
                let newId;
                for(let key in item) {
                  if(key == value){
                    newId = item[key]
                    break;
                  }
                }
              
                return {...item,label: `${label2}`, value: newId}
                 
              });
           
              if(appendTopOption.length > 0){
                for(const item in appendTopOption){
                  transformedOptions.unshift(appendTopOption[item])
                }
              }
    
              if(appendBottomOption.length > 0){
                for(let item in appendBottomOption){
                  transformedOptions.push(appendBottomOption[item])
                }
              }
            
              setOptions2({[id] : transformedOptions});
            }
            
      
         
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
      
    }, [url]);

    return (
      <div style={{zIndex:100,position:"relative"}}>
        <VirtualizedSelect 
              options={options2[id]}
              onChange={(option) => handleOnchange(option)}
              //value={selectedValue2[id]}
              value={selectedvalue}
              clearable={clearable}
              searchable={searchable}
              disabled={disabled}
              placeholder={placeholder}
              required={required}
            //  ref={(ref) => optionsRef = ref}
            //  style={{zIndex:200}}
              id={id}
       />
      </div>
        
    )
    
}

export default DynamicSelect